module.exports = __webpack_public_path__ + "img/route__all_s.3ab30926.svg";